module.exports = __webpack_public_path__ + "static/media/tellMeLogo.cd1ecc81.PNG";